/**
 * <s-sticky-buy> — keeps only one Add to cart visible at a time.
 *
 * The bar is CSS-sticky at the bottom of the page below the product grid. This element hides it
 * (data-hidden + inert) whenever the main Add to cart button (data-target selector) is on screen,
 * so shoppers never see two buttons at once. Without JS the bar simply stays sticky.
 */
class SStickyBuy extends HTMLElement {
  #observer;

  connectedCallback() {
    const target = document.querySelector(this.dataset.target || '');
    if (!target) return;
    this.#observer = new IntersectionObserver(([entry]) => {
      const mainVisible = entry.isIntersecting;
      this.toggleAttribute('data-hidden', mainVisible);
      this.inert = mainVisible;
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', SStickyBuy);
